import * as React from 'react';
import clsx from 'clsx';
import { EmailSettings } from './EmailSettings';
import { PasswordSettings } from './PasswordSettings';
import { NotificationSettings } from './NotificationSettings';
import { DeleteSection } from './DeleteSection';
import { StripeCard } from './StripeCard';

export const SettingsTab: React.FC = () => (
  <div className='animate-slide-in flex w-full flex-col pt-2'>
    <div className={clsx('flex w-full', 'flex-col gap-8', 'xl:flex-row xl:items-start xl:gap-0')}>
      {/* STRIPE CARD — mobile: first, desktop: hidden (shown in right column) */}
      <div className='w-full xl:hidden'>
        <StripeCard />
      </div>

      {/* LEFT COLUMN */}
      <div className='flex min-w-0 flex-1 flex-col'>
        <div className='flex w-full max-w-4xl flex-col gap-12'>
          <div className='flex flex-col gap-8'>
            <EmailSettings />
            <PasswordSettings />
            <NotificationSettings />
          </div>

          <div className='h-px w-full bg-gray-200' />

          <DeleteSection />
        </div>
      </div>

      {/* DIVIDER */}
      <div className='mx-10 hidden h-auto min-h-[400px] w-px bg-gray-300 xl:block' />

      {/* RIGHT COLUMN — desktop only */}
      <div className='hidden shrink-0 xl:block xl:w-auto'>
        <StripeCard />
      </div>
    </div>
  </div>
);
